export default "__VITE_ASSET__2be21e7f__"